module.exports = __webpack_public_path__ + "static/media/FacialsNew.23674ff3.png";